export enum StatusesEnum {
    Pending = 1,
    Approved = 3,
    Rejected = 4
}
